import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


export const constantRoutes = [
  {
    path: '/',
    redirect: '/home', // 添加根路径的重定向
  },
  {
    path: '/home',
    component: () => import('@/views/home/index.vue'),
  },
  {
    path: '/price',
    component: () => import('@/views/price/index.vue'),
  },
  {
    path: '/article',
    component: () => import('@/views/article/index.vue'),
  },
  {
    path: '/articleDetail',
    component: () => import('@/views/article/detail.vue'),
  },
  {
    path: '/test/xys/test1',
    component: () => import('@/views/test/xys/test1.vue'),
  },
];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return routerPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes,
});

export default router;
